import React, { useEffect } from 'react'
import styled from 'styled-components'
import DefaultMaps from '../../assets/image/delivery/img_default_maps.png'
const { kakao } = window

const KakaoMaps = ({ storePolygon, storePoint }) => {
  // 1. 줌 레벨 측정을 위해 다각형(polygon) 면적 계산식
  const calculateArea = (coords) => {
    let area = 0

    // 폴리곤 사다리꼴 계산
    for (let i = 0; i < coords.length; i++) {
      const current = coords[i]
      const next = coords[(i + 1) % coords.length] // 다음 인덱스(i % 8)

      // 각 꼭지점을 순회하면서 사다리꼴의 면적 계산식
      area +=
        parseFloat(current.longitude) * parseFloat(next.latitude) -
        parseFloat(next.longitude) * parseFloat(current.latitude)
    }

    // 제곱미터를 제곱킬로미터로 변환
    area = (Math.abs(area) / 2.0) * Math.pow(10, 6)

    return area
  }

  // 2. area(면적)마다 줌 레벨 변경
  function getZoomLevel(area) {
    if (area < 100) {
      return 5 // 작은 면적에 대한 줌 레벨
    } else if (area < 150) {
      return 6 // 중간 면적에 대한 줌 레벨
    } else {
      return 7 // 큰 면적에 대한 줌 레벨
    }
  }

  useEffect(() => {
    if (storePolygon && storePoint) {
      const container = document.getElementById('map')
      // const storePolygonWKT =
      //   'MULTIPOLYGON(((129.0863806113071 35.23152144381868,129.08912580450112 35.23235719935653,129.09117810691475 35.230158993839666,129.0887107852736 35.22816501861949,129.0851877052726 35.229541459814385,129.0863806113071 35.23152144381868)))'

      // 지도 다각형 : storePolygon(MULTIPOLYGON 배열)
      // {latitude: '37.243288303262986', longitude: '131.86042935723606'}
      const coordinate = storePolygon
        .match(/(\d+\.\d+)\s(\d+\.\d+)/g)
        .map((match) => {
          const [longitude, latitude] = match.split(' ')
          return { latitude, longitude }
        })
      console.log('coordinate___', coordinate)

      // 지도 포인터 : storePoint(POINT 배열)
      const pointer = storePoint
        .match(/(\d+\.\d+)\s(\d+\.\d+)/g)
        .map((match) => {
          const [longitude, latitude] = match.split(' ')
          return { latitude, longitude }
        })

      const polygonArea = calculateArea(coordinate)
      // console.log('다각형 면적(K㎡):', polygonArea)

      const zoomLevel = getZoomLevel(polygonArea)
      // console.log('적용된 줌 레벨:', zoomLevel)

      let polygonPath = []
      {
        coordinate.map((coordinate, index) =>
          polygonPath.push(
            new kakao.maps.LatLng(coordinate.latitude, coordinate.longitude),
          ),
        )
      }

      // 위도 좌표 총합
      const sumLatitude = coordinate.reduce(
        (acc, coord) => acc + parseFloat(coord.latitude),
        0,
      )
      // 경도 좌표 총합
      const sumLongitude = coordinate.reduce(
        (acc, coord) => acc + parseFloat(coord.longitude),
        0,
      )

      //지도의 중심좌표 (평균값)
      const avgLatitude = sumLatitude / coordinate.length
      const avgLongitude = sumLongitude / coordinate.length

      const options = {
        center: new kakao.maps.LatLng(avgLatitude, avgLongitude), //지도의 중심좌표
        level: zoomLevel, // 지도의 확대 레벨
      }

      // 카카오 맵 생성(화면 렌더링)
      const map = new kakao.maps.Map(container, options)

      // 폴리콘 스타일 적용
      let polygon = new kakao.maps.Polygon({
        path: polygonPath,
        strokeWeight: 3,
        strokeColor: '#ff0015',
        strokeOpacity: 0.8,
        strokeStyle: 'longdash',
        fillColor: '#f3e179',
        fillOpacity: 0.7,
      })
      polygon.setMap(map)

      // 포인터(마커) 생성
      const markerPosition = new window.kakao.maps.LatLng(
        pointer[0].latitude,
        pointer[0].longitude,
      )
      // 포인터 좌표 설정
      const marker = new window.kakao.maps.Marker({
        position: markerPosition,
      })

      marker.setMap(map)

      // 줌 컨트롤 추가
      const zoomControl = new kakao.maps.ZoomControl()
      map.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT)

      // kakao.maps.event.addListener(map, 'zoom_changed', () => {
      //   const currentZoomLevel = map.getLevel()
      //   console.log(`현재 줌 레벨: ${currentZoomLevel}`)
      // })
    }
  }, [storePolygon, storePoint])

  return (
    <MapContainer>
      {storePolygon && storePoint ? (
        <div id="map"></div>
      ) : (
        <DefaultMapsWrap>
          <p>배달 지역 준비중</p>
          {/* <img src={DefaultMaps} alt="" /> */}
        </DefaultMapsWrap>
      )}
    </MapContainer>
  )
}

export default KakaoMaps

const MapContainer = styled.div`
  width: 100%;
  #map {
    width: '100%';
    height: 350px;
  }
  @media screen and (min-width: 400px) {
    width: 100%;
  }
`
const DefaultMapsWrap = styled.div`
  width: 100%;
  height: 350px;
  background: url(${DefaultMaps}) center;
  object-fit: contain;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  font-size: 24px;
  text-align: center;
`
